module.exports = __webpack_public_path__ + "img/bench.08127bb8.jpg";